import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from './firebase';
import { useAuth } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';

import Login from './pages/Login';
import ClientProfile from './pages/ClientProfile';
import ClientList from './pages/ClientList';
import NewClientForm from './pages/NewClientForm';
import AdminDashboard from './pages/AdminDashboard';
import OrdersPage from './pages/OrdersPage';
import AddOrderPage from './pages/AddOrderPage';
import ViewOrderPage from './pages/ViewOrderPage';
import ClientDashboard from './pages/ClientDashboard';
import ClientViewOrder from './pages/ClientViewOrder';
import FacebookEventsPageWrapper from './pages/FacebookEventsPageWrapper';
import DockNav from './components/DockNav';
import './styles/fonts.css';
import MessagesPage from './pages/MessagesPage';
import AnalyticsPage from './pages/AnalyticsPage';
import AssetsPage from './pages/AssetsPage';

function App() {
  const { currentUser, userData } = useAuth();

  // eslint-disable-next-line 
  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Logout failed', error);
    }
  };

  const shouldShowDock =
    currentUser &&
    ['admin', 'client', 'facebookAdmin', 'facebook'].includes(userData?.role);

  return (
      <div style={{ paddingBottom: shouldShowDock ? '100px' : '0' }}>
        
        
        <Routes>
          {/* Login Page */}
          <Route path="/login" element={<Login />} />

          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <>
                  <AdminDashboard />
                </>
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <OrdersPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/edit-order/:orderId"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <ViewOrderPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/assets"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AssetsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/messages"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <MessagesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/orders/new"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AddOrderPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders/:orderId"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <ViewOrderPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/analytics"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AnalyticsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/clients"
            element={
              <ProtectedRoute allowedRoles={['admin', 'facebookAdmin']}>
                <>
                  <ClientList />
                </>
              </ProtectedRoute>
            }
          />
          <Route
            path="/clients/new"
            element={
              <ProtectedRoute allowedRoles={['admin', 'facebookAdmin']}>
                <NewClientForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clients/:id"
            element={
              <ProtectedRoute allowedRoles={['admin', 'facebookAdmin']}>
                <ClientProfile />
              </ProtectedRoute>
            }
          />

          {/* Facebook Team Route */}
          <Route
            path="/facebook-events"
            element={
              <ProtectedRoute allowedRoles={['admin', 'facebookAdmin', 'facebook']}>
                <>
                  <FacebookEventsPageWrapper />
                </>
              </ProtectedRoute>
            }
          />

          {/* Client Routes */}
          <Route
            path="/client-dashboard"
            element={
              <ProtectedRoute allowedRoles={['client']}>
                <>
                  <ClientDashboard />
                </>
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/orders/:orderId"
            element={
              <ProtectedRoute allowedRoles={['client']}>
                <ClientViewOrder />
              </ProtectedRoute>
            }
          />

          {/* Root Redirect */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                {userData?.role === 'admin' && <Navigate to="/admin" replace />}
                {userData?.role === 'facebookAdmin' && <Navigate to="/facebook-events" replace />}
                {userData?.role === 'facebook' && <Navigate to="/facebook-events" replace />}
                {userData?.role === 'client' && <Navigate to="/client-dashboard" replace />}
                {!userData?.role && <Navigate to="/login" replace />}
              </ProtectedRoute>
            }
          />
        </Routes>

        {/* DockNav shown at bottom for authorized users */}
        {shouldShowDock && <DockNav />}
      </div>
  );
}

export default App;